import React, { useState, useEffect } from "react";
import PegaGadgetHTML from "../PegaGadgetHTML";

const PegaGadget = () => {
  const [showPegaGadget, setShowPegaGadget] = useState(false);
  const currentToken = localStorage.getItem("nonCommitteeToken");
  useEffect(() => {
    if (currentToken) {
      const hasRefreshed = sessionStorage.getItem("hasRefreshed");
      setShowPegaGadget(true);
      if (!hasRefreshed) {
        sessionStorage.setItem("hasRefreshed", "true");
        window.location.reload();
      }
    } else {
      const interval = setInterval(() => {
        if (currentToken) {
          setShowPegaGadget(true);
          clearInterval(interval);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [currentToken]);

  return showPegaGadget && <PegaGadgetHTML currentToken={currentToken} />;
};

export default PegaGadget;
